import React, { useState, useEffect } from "react";
import global from "../../global-variables";
import Header from "../layout/header";
import { Link } from "react-router-dom";
import $ from "jquery";
import WOW from "wowjs";
import { Container, Row, Col } from "reactstrap";
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { HashLink } from "react-router-hash-link";
import axios from "axios";
import Metatag from '../../hooks/Metatag'
export default function Sitemap() {
    const [toggler, setToggler] = useState(true);
    const [index, setIndex] = useState(0);

    const handleSelect = (selectedIndex, e) => {
        setIndex(selectedIndex);
    };

    const scrollWithOffset = (el) => {
        const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
        const yOffset = -134;
        window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' });
    }

    useEffect(() => {
        // add class for home header and remove inner class
        $(".fixed-top").addClass("bg-header");

        // initiate the wow effect
        new WOW.WOW({
            live: false,
        }).init();


    }, []);

    const [peopleCategory, setPeopleCategoryList] = useState([]);

    useEffect(() => {
        let _obj = new Object();
        _obj.pcategory_status = 1;
        

            axios.post(global.variables.strApiUrl + "/peoplecategoryApi/getcategoryHavingPeopleList", _obj)
                .then((response_list) => {
                    // pass the result in the success function of the respective page
                    setPeopleCategoryList(response_list.data[0]);
                });
        

    }, [])

    
    const [diseaseCategory, setDiseaseCategoryList] = useState([]);
    

    useEffect(() => {
        let _obj = new Object();
        _obj.disease_cat_status = 1;
        // setTimeout(() => {

            axios.post(global.variables.strApiUrl + "/diseasecategoryApi/getcategoryHavingDiseaseList", _obj)
                .then((response_list) => {
                    // pass the result in the success function of the respective page
                    setDiseaseCategoryList(response_list.data[0]);
                });
        // }, 300);

    }, [])
    
    const [disease, setDiseaseList] = useState([]);

    useEffect(() => {
        let _obj = new Object();
        _obj.disease_status = 1;
        // setTimeout(() => {

            axios.post(global.variables.strApiUrl + "/diseaseApi/getdiseaseList", _obj)
                .then((response_list) => {
                    // pass the result in the success function of the respective page
                    setDiseaseList(response_list.data[0]);
                });
        // }, 300);

    }, [])

    return (
        <>
            <Header main_className="bg-header"></Header>
            {/* Metatag  */}
            <Metatag title='Sitemap | National Diseases Modelling Consortium'
                    keywords='Sitemap, National Diseases Modelling Consortium' 
                    description='Sitemap of National Diseases Modelling Consortium'
                    />
            <Container fluid className="px-0 bg-visual position-relative" style={{ backgroundImage: "url('./images/bg-about.jpg')", backgroundSize: "cover", backgroundRepeat: "no-repeat", backgroundPosition: "center" }}>
                <img src={global.variables.strDomainUrl + "images/bg-blank.png"} alt="" title="" className="w-100" />
                <div className="masthead d-flex align-items-center w-100">
                    <Container className="px-4 px-md-5">
                        <h1 className="mb-0 fw-bold text-white text-uppercase pb-xl-5 py-4">Site map</h1>
                    </Container>
                </div>
            </Container>

            <Container className="p-md-5 p-4 content-bg bordr bg-white rounded-3 shadow-sm">

                <div className="mb-5 col-xl-10">
                    <div className="d-md-flex sitemap justify-content-between pe-lg-5">
                        <div className="mb-4 mb-lg-0">
                            <h6>About Us</h6>
                            <ul className="list-group list-group-flush">
                                <li className="list-group-item bg-transparent px-0 border-0 pt-0 pb-1"><Link to="/aboutus">Introduction</Link></li>
                                <li className="list-group-item bg-transparent px-0 border-0 pt-0 pb-1"><HashLink to="/aboutus#objectives" scroll={el => scrollWithOffset(el)}>Objectives</HashLink></li>
                                <li className="list-group-item bg-transparent px-0 border-0 pt-0 pb-1"><HashLink to="/aboutus#whyiitb" scroll={el => scrollWithOffset(el)}>Why IITB</HashLink></li>
                                <li className="list-group-item bg-transparent px-0 border-0 pt-0 pb-1"><Link to="/milestone">Milestones</Link></li>
                            </ul>
                        </div>
                        <div className="mb-4 mb-lg-0">
                            <h6>People</h6>
                            <ul className="list-group list-group-flush">
                                {
                                    peopleCategory.map((val_people)=>{
                                        return(

                                            <li className="list-group-item bg-transparent px-0 border-0 pt-0 pb-1"><Link to={global.variables.strDomainUrl + "people/" + val_people.pcategory_pagename}>{val_people.pcategory_name}</Link></li>
                                        )

                                    })
                                }
                                
                            </ul>
                        </div>
                        <div className="mb-4 mb-md-0">
                            <h6>Disease</h6>
                            <ul className="list-group list-group-flush">
                            {
                                                        diseaseCategory.map((val)=>{
                                                            
                                                            return(
                                                                <>
                                                             
                                                                    {
                                                                            // if disease diff is same then show text else link 
                                                                        val.disease_diff_name != null &&  val.disease_diff_name != "null"? 
                                                                        <li className='list-group-item bg-transparent px-0 border-0 pt-0 pb-1'>{val.disease_cat_name}</li> 
                                                                        : 
                                                                        <li className="list-group-item bg-transparent px-0 border-0 pt-0 pb-1"><Link to={global.variables.strDomainUrl + "disease/" + val.disease_pagename}>{val.disease_cat_name}</Link></li>
                                                                                    
                                                                    }
                                                                   {
                                                                    disease.map((val_disease)=>{
                                                                        return(
                                                                            <>
                                                                            
                                                                                {
                                                                                    // if disease count is greater than one and categroy id equal to disease_disease_cat_id
                                                                                    val.disease_count > 1  && val.disease_cat_id === val_disease.disease_disease_cat_id ? 
                                                                                    <li className="list-group-item bg-transparent px-0 border-0 pt-0 pb-1"><Link to={global.variables.strDomainUrl + "disease/" + val_disease.disease_pagename} className='fw-normal ms-2'>- {val_disease.disease_name}</Link></li> 
                                                                                    : 
                                                                                        null
                                                                                }

                                                                                {
                                                                                    // if disease count is equal and disease_cat_name not equal to disease_name
                                                                                    val.disease_count === 1 && val.disease_cat_name != val_disease.disease_name  && val.disease_cat_id === val_disease.disease_disease_cat_id ? 
                                                                                    <li className="list-group-item bg-transparent px-0 border-0 pt-0 pb-1"><Link to={global.variables.strDomainUrl + "disease/" + val_disease.disease_pagename} className='fw-normal ms-2'>- {val_disease.disease_name}</Link></li> 
                                                                                    : 
                                                                                        null
                                                                                }

                                                                            </>
                                                                        
                                                                               
                                                                        )
                                                                        
                                                                    })
                                                                   }
                                                            </>     
                                                            )
                                                        })
                                                    }
                                {/* <li className="list-group-item bg-transparent px-0 border-0 pt-0 pb-1"><Link to="/malaria">Malaria</Link></li>
                                <li className="list-group-item bg-transparent px-0 border-0 pt-0 pb-1"><Link to="/tuberculosis">Tuberculosis</Link></li>
                                <li className="list-group-item bg-transparent px-0 border-0 pt-0 pb-1">Vaccine Preventable Disease (VPDs)</li>
                                <li className="list-group-item bg-transparent px-0 border-0 pt-0 pb-2 ps-3"><Link to="/measles">- Measles</Link></li>
                                <li className="list-group-item bg-transparent px-0 border-0 pt-0 pb-1">Neglected Tropical Diseases (NTDs)</li>
                                <li className="list-group-item bg-transparent px-0 border-0 pt-0 pb-1 ps-3"><Link to="/neglected-tropical-diseases">- Lymphatic filariasis</Link></li>
                                <li className="list-group-item bg-transparent px-0 border-0 pt-0 pb-1 ps-3"><HashLink to="/neglected-tropical-diseases#Visceralleishmaniasis" scroll={el => scrollWithOffset(el)}>- Visceral leishmaniasis</HashLink></li> */}
                            </ul>
                        </div>
                        <div>
                            <h6>Quick Links</h6>
                            <ul className="list-group list-group-flush">
                                <li className="list-group-item bg-transparent px-0 border-0 pt-0 pb-1"><Link to={global.variables.strDomainUrl}>Home</Link></li>
                                <li className="list-group-item bg-transparent px-0 border-0 pt-0 pb-1"><Link to="/events">News & Events</Link></li>
                                <li className="list-group-item bg-transparent px-0 border-0 pt-0 pb-1"><Link to="/publications">Publications</Link></li>
                                <li className="list-group-item bg-transparent px-0 border-0 pt-0 pb-1"><Link to="/resources">Resources</Link></li>
                                {/* <li className="list-group-item bg-transparent px-0 border-0 pt-0 pb-1"><Link to="/blog">Blog</Link></li> */}
                                <li className="list-group-item bg-transparent px-0 border-0 pt-0 pb-1"><Link to="/contactus">Contact Us</Link></li>
                            </ul>
                        </div>
                    </div>
                </div>


            </Container >


            {/* Breadcrumb */}
            <Container fluid className="small pt-3 p-0 bg-white d-flex justify-content-center mt-auto" >
                <Breadcrumb>
                    <Breadcrumb.Item href={global.variables.strDomainUrl}>Home</Breadcrumb.Item>
                    <Breadcrumb.Item active>Sitemap</Breadcrumb.Item>
                </Breadcrumb>
            </Container>
            {/* Breadcrumb */}
        </>
    );
}